/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  Form,
  Collapse,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { setUserSettings } from '../../actions/Auth';

import { APIupdateUserSettings } from '../../api/User';

import AccessModalAccessList from './ModalAccessList';
import AccessModalAccessSelect from './ModalAccessSelect';
import AvatarStack from '../AvatarStack';

import { userIsAdmin } from '../../helpers/Auth';
import {
  getSetting,
  getUserSetting,
} from '../../helpers/Settings';

const AccessModalAccess = ({
  dispatch,
  profile,
  loading,
  selectedUsers,
  selectedGroups,
  ...props
}) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(getUserSetting('access_toggle_open'));

  const switchIsOpen = () => {
    APIupdateUserSettings(profile.uuid, { access_toggle_open: !isOpen }).then((response) => {
      dispatch(setUserSettings(response.data));
    });
    setIsOpen(!isOpen);
  };

  const showTeams = !getSetting('cs1') || userIsAdmin();
  const items = showTeams ? props.groups.concat(props.users) : props.users;
  const selected = Object.keys({
    ...selectedGroups,
    ...selectedUsers,
  }).map((uuid) => {
    const item = items.find(i => (i.uuid === uuid));
    if (!item) {
      return false;
    }
    return ({
      uuid,
      type: item.email ? 'user' : 'group',
      name: item.name ? item.name : '',
      email: item.email ? item.email : undefined,
      avatar_url: item.avatar_url ? item.avatar_url : null,
    });
  }).filter(s => (s !== false));
  const accessCount = selected.length;

  return (
    <div className={classnames('access-body', { 'access-body-open': isOpen })}>
      <div className="access-body-container">
        <h5
          className="collaborate-add-header"
          onClick={switchIsOpen}
          onKeyUp={switchIsOpen}
        >
          {isOpen ? (
            <i className="far fa-angle-down" />
          ) : (
            <i className="far fa-angle-right" />
          )}
          {' '}{intl.formatMessage({ defaultMessage: 'Users and Teams with access' })} ({accessCount})
        </h5>
        <AvatarStack
          users={selected}
          size={25}
          inModal={true}
          onClick={switchIsOpen}
        />
      </div>

      <Collapse isOpen={isOpen}>
        <Form className="access-add-users-form access-add-form">
          <AccessModalAccessSelect
            {...props}
            selectedGroups={selectedGroups}
            selectedUsers={selectedUsers}
            loading={loading}
            showTeams={showTeams}
            showAddNewButton={true}
          />
        </Form>

        <AccessModalAccessList
          {...props}
          selectedGroups={selectedGroups}
          selectedUsers={selectedUsers}
          loading={loading}
        />
      </Collapse>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

AccessModalAccess.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  groups: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired,
  selectedUsers: PropTypes.object.isRequired,
  selectedGroups: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AccessModalAccess);
